import { render, staticRenderFns } from "./battery-statistics.vue?vue&type=template&id=46aa5609&"
import script from "./battery-statistics.vue?vue&type=script&lang=js&"
export * from "./battery-statistics.vue?vue&type=script&lang=js&"
import style0 from "./battery-statistics.vue?vue&type=style&index=0&id=46aa5609&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports